import script from "./notFound.vue?vue&type=script&setup=true&lang=js"
export * from "./notFound.vue?vue&type=script&setup=true&lang=js"

import "./notFound.vue?vue&type=style&index=0&id=76bd538c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76bd538c"]])

export default __exports__